import { Button, DataSource, Label, Layout, Panel, Table, Textbox} from "@mcleod/components";

export abstract class AutogenLayoutAdditionalDetailsLTL extends Layout {
	buttonBOL: Button;
	buttonShare: Button;
	labelConsigneeContact: Label;
	labelLabel1: Label;
	labelLabel2: Label;
	labelOrderEmail: Label;
	labelShipperContact: Label;
	panel1: Panel;
	panelBilling: Panel;
	panelCarrier: Panel;
	panelConsigneeContact: Panel;
	panelShipperContact: Panel;
	sourceCustomerOrderDetail: DataSource;
	sourceOrderReferenceNumbers: DataSource;
	tableReferenceNumbers: Table;
	textboxBillingMethod: Textbox;
	textboxCustomername: Textbox;
	textboxLastKnownLocation: Textbox;
	textboxPayeename: Textbox;
}
